import { useResizeObserver } from '@flex-design-system/fx-utils/hooks';
import { setElementVars } from '@vanilla-extract/dynamic';
import { useCallback, useEffect } from 'react';
import { segmentedControlIndicatorLeft, segmentedControlIndicatorTop, segmentedControlIndicatorHeight, segmentedControlIndicatorWidth } from '../components/indicator/indicator.vanilla.mjs';

function useSyncIndicatorToActiveItem(params) {
  const { indicatorElement, rootElement, value } = params;
  const syncIndicatorToActiveElement = useCallback(() => {
    if (indicatorElement === null || rootElement === null || !value) {
      return;
    }
    const activeElement = rootElement.querySelector(
      `[data-value="${CSS.escape(value)}"]`
    );
    if (activeElement === null) {
      return;
    }
    const { top: rootElementTop, left: rootElementLeft } = rootElement.getBoundingClientRect();
    const {
      width: activeElementWidth,
      height: activeElementHeight,
      top: activeElementTop,
      left: activeElementLeft
    } = activeElement.getBoundingClientRect();
    setElementVars(indicatorElement, {
      [segmentedControlIndicatorWidth]: `${activeElementWidth}px`,
      [segmentedControlIndicatorHeight]: `${activeElementHeight}px`,
      [segmentedControlIndicatorTop]: `${activeElementTop - rootElementTop}px`,
      [segmentedControlIndicatorLeft]: `${activeElementLeft - rootElementLeft}px`
    });
  }, [indicatorElement, rootElement, value]);
  useEffect(syncIndicatorToActiveElement, [syncIndicatorToActiveElement]);
  useResizeObserver(rootElement, syncIndicatorToActiveElement);
}

export { useSyncIndicatorToActiveItem };
//# sourceMappingURL=useSyncIndicatorToActiveItem.mjs.map
